import styled from 'styled-components';

export const StyledClientList = styled.ul`
  margin: 24px 0;

  &:last-child {
    margin-bottom: 0;
  }
`;
